import { UserRoleEnum } from 'APIPackage/AuthModule/enums/UserRoleEnum';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const rolesDict: Record<number, ISelectOption> = {
  1: { id: 1, value: UserRoleEnum.SUPERVISOR, label: 'Сотрудник КНО' },
  2: { id: 2, value: UserRoleEnum.PROSECUTOR, label: 'Работник прокуратуры' },
  3: { id: 3, value: UserRoleEnum.OMBUDSMAN, label: 'Омбудсмен' },
  4: { id: 4, value: UserRoleEnum.NEWS_ADMIN, label: 'Администратор новостей' },
  5: { id: 5, value: UserRoleEnum.ADMIN, label: 'Администратор' },
  6: { id: 6, value: UserRoleEnum.OPEN_PART, label: 'Открытая часть' },
  7: { id: 7, value: UserRoleEnum.SUPERIOR_PROSECUTOR, label: 'Вышестоящий прокурор' },
};
